<template>
  <div
    class="relative select-none"
    v-on:mouseleave="nested.hide.value = true"
    v-on:mouseover="nested.hide.value = false"
  >
    <div
      class="shadow-md ml-4 my-2 p-1 flex rounded-full border-2 border-gray-500 dark:border-dark-text-dark dark:text-dark-text-dark cursor-pointer hover:bg-gray-200 hover:dark:bg-dark"
      style="transition: background-color 0.5s"
    >
      <span class="material-icons" style="margin-left: 0.25px; margin-right: 0.25px">
        {{ titleIcon }}
      </span>
    </div>
    <Transition name="slide-fade">
      <ul v-show="!nested.hide.value" class="absolute bottom-full mb-2 drop-card">
        <li>
          <div class="flex my-3">
            <span
              class="material-icons p-2 rounded-full bg-primary hover:bg-primary-600 active:bg-primary-700 text-white shadow-md cursor-pointer"
              style="margin-left: 0.25px; margin-right: 0.25px; transition: background-color 0.5s"
              @click="changeFreeSpaceMode"
            >
              space_dashboard
            </span>
            <div class="text-sm my-auto ml-2 whitespace-nowrap">
              {{ $t('message.freeSpace') }}
            </div>
          </div>
        </li>
        <li>
          <label class="flex my-3 relative">
            <div class="flex items-center">
              <span
                class="material-icons p-2 rounded-full bg-primary shadow-md hover:bg-primary-600 active:bg-primary-700 text-white cursor-pointer transition-colors duration-200"
                style="margin-left: 0.25px; margin-right: 0.25px"
              >
                upload
              </span>
              <div class="text-sm my-auto ml-2 whitespace-nowrap">
                {{ $t('message.upload') }}
              </div>
            </div>
            <input
              class="hidden"
              type="file"
              @change="event => editorPageStatePresenter.uploadSourceCode(event as InputEvent)"
            />
          </label>
        </li>
        <li>
          <div class="flex my-3">
            <span
              class="material-icons p-2 rounded-full bg-primary hover:bg-primary-600 active:bg-primary-700 text-white shadow-md cursor-pointer"
              style="margin-left: 0.25px; margin-right: 0.25px; transition: background-color 0.5s"
              @click="editorPageStatePresenter.downloadSourceCode"
            >
              download
            </span>
            <div class="text-sm my-auto ml-2 whitespace-nowrap">
              {{ $t('message.download') }}
            </div>
          </div>
        </li>
        <li>
          <div class="flex my-3">
            <span
              class="material-icons p-2 rounded-full bg-primary hover:bg-primary-600 active:bg-primary-700 text-white shadow-md cursor-pointer"
              style="margin-left: 0.25px; margin-right: 0.25px; transition: background-color 0.5s"
              @click="increaseFontSize"
            >
              add
            </span>
            <div class="text-sm my-auto ml-2 whitespace-nowrap">
              {{ $t('message.zoomIn') }}
            </div>
          </div>
        </li>
        <li>
          <div class="flex my-3">
            <span
              class="material-icons p-2 rounded-full bg-primary hover:bg-primary-600 active:bg-primary-700 text-white shadow-md cursor-pointer"
              style="margin-left: 0.25px; margin-right: 0.25px; transition: background-color 0.5s"
              @click="decreaseFontSize"
            >
              remove
            </span>
            <div class="text-sm my-auto ml-2 whitespace-nowrap">
              {{ $t('message.zoomOut') }}
            </div>
          </div>
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useEditorPageStatePresenter } from '@/presentation/composables/editor/useEditorPageStatePresenter'
import { useJudgeDetailPresenter } from '@/presentation/composables/judge/useJudgeDetailPresenter'
import { useNotificationPresenter } from '@/presentation/composables/notification/useNotificationPresenter'

export default defineComponent({
  props: {
    titleIcon: {
      type: String,
      default: ''
    }
  },
  setup(props, ctx) {
    const hide = ref(true)

    const editorPageStatePresenter = useEditorPageStatePresenter()
    const notificationPresenter = useNotificationPresenter()
    const { editorFontSize, setEditorFontSize } = useConfigStatePresenter()
    const { judgeDetail } = useJudgeDetailPresenter()

    const increaseFontSize = () => {
      setEditorFontSize(editorFontSize.value + 1)
    }

    const decreaseFontSize = () => {
      setEditorFontSize(editorFontSize.value - 1)
    }

    const changeFreeSpaceMode = () => {
      editorPageStatePresenter.reverseIsFreeSpaceMode()
    }

    return {
      nested: { hide },
      increaseFontSize,
      decreaseFontSize,
      changeFreeSpaceMode,
      editorPageStatePresenter
    }
  }
})
</script>

<style lang="postcss" scoped>
.drop-card {
  @apply z-10 absolute;
  bottom: 2.5rem;
  left: 0.88rem;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>
